import React, { useEffect } from 'react'
import styled from 'styled-components'
import Normal from './Normal'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { axiosPost } from '../../Common/Axios'
import { ApiResult } from '../../../models/Enums'
import { StudentRole } from '../../../models/User'
import Evaluator from './Evaluator'
import JobRegister from './JobRegister'
import { setStudentRole } from '../../../store/userSlice'

function MenteeJobClass() {
  const me = useAppSelector((state: RootState) => state.user.me)
  const dispatch = useAppDispatch()

  const updateStudentRole = async () => {
    const payload = {
      userGroupId: me.groupId,
      userId: me.id,
    }
    const result = await axiosPost('/api/jobs/get_student_role', payload)
    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('get_student_role error', result.message)
      return
    }

    console.log('updateStudentRole', result.data)

    dispatch(setStudentRole(result.data))
  }

  useEffect(() => {
    if (me.studentRole === undefined || me.studentRole === StudentRole.NORMAL) {
      updateStudentRole()
    }
    console.log('studentRole', me.studentRole)
  }, [])

  return (
    <Container>
      {me.studentRole === StudentRole.NORMAL && <Normal />}
      {me.studentRole === StudentRole.REGISTER && <JobRegister />}
      {me.studentRole === StudentRole.EVALUATOR && <Evaluator />}
    </Container>
  )
}

const Container = styled.div``

export default MenteeJobClass
